import classNames from 'classnames';
import { FC } from 'react';

interface iToggleProps {
  options: string[];
  value?: boolean;
  onChange?: (val: boolean | string) => void;
  label: string;
}
const Toggle: FC<iToggleProps> = ({ options, value, onChange, label }) => {
  const _handleChange = (val: boolean, option: string) => () => onChange?.(typeof value === 'undefined' ? option : val);
  return (
    <div className='toggle-container'>
      <span>{label}</span>
      <div className='toggle-wrapper'>
        {options.map((option, i) => {
          const val = i === 0 ? true : false;
          return (
            <div
              key={option}
              onClick={_handleChange(val, option)}
              className={classNames('option-wrapper', value === val && 'active')}
            >
              {option}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Toggle;
